// extracted by mini-css-extract-plugin
export var container = "_gk-1";
export var cornerButtonContainer = "_gk-6";
export var disabled = "_gk-2";
export var dragActive = "_gk-3";
export var fileContainer = "_gk-5";
export var hiddenInput = "_gk-4";
export var widthContainer = "_gk-0";